import { Box, FormControl, makeStyles, MenuItem, Select } from '@material-ui/core';
import { getLoanById, Ticketing, Tickets } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface TicketSelectorProps {
  loanId: string;
  tickets: Tickets;
  selectedTicketing: Ticketing;
  setSelectedTicketing;
}

export const TicketSelector = ({ loanId, tickets, selectedTicketing, setSelectedTicketing }: TicketSelectorProps) => {
  const { data: loan } = useCache(getLoanById, { loanId }, { revalidateOnMount: false });

  const { customBorderRadius, palette } = useCustomTheme();

  const selectedOnboardingDetails = (ticket) =>
    loan?.onboardingDetails.find(
      (details) => details.invitation.email === ticket.comments[ticket.comments.length - 1].author.email,
    );

  const styleDefinition = {
    root: {
      '& .MuiFilledInput-underline:before': {
        content: 'none',
      },
      '& .MuiFilledInput-underline.Mui-focused:after': {
        content: 'none',
      },
      '& .MuiFilledInput-input': {
        padding: '10px 12px',
        minHeight: '36px',
      },
      '& .MuiTypography-root': {
        overflow: 'hidden',
        maxWidth: '260px',
        textOverflow: 'ellipsis',
      },

      '& .MuiSelect-root': {
        background: palette.grey[50],
        borderRadius: customBorderRadius.paper,
      },
      '& .MuiFilledInput-root': {
        height: '56px',
        borderRadius: customBorderRadius.paper,
      },
      '& .MuiSelect-icon': {
        color: palette.text.primary,
      },
    },
  };
  const useStyles = makeStyles(styleDefinition);

  const classes = useStyles();

  return (
    <Box pb={4}>
      <FormControl className={classes.root} variant="filled">
        <Select value={selectedTicketing} onChange={(e) => setSelectedTicketing(e.target.value)}>
          {tickets.ticketing.map((ticket) => (
            <MenuItem value={ticket} key={ticket.content.id}>
              <Box display={'flex'} flexDirection={'column'} mr={3}>
                <Font variant={'overline'} color={'title'}>
                  <Text tId={selectedOnboardingDetails(ticket)?.role} />
                </Font>
                <Font variant={'h5'} color={'title'}>
                  {`${selectedOnboardingDetails(ticket)?.invitation.fullName.firstName} ${
                    selectedOnboardingDetails(ticket)?.invitation.fullName.lastName
                  }`}
                </Font>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
